"use client";

import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";

const LGPD_KEY = "lgpd_alert_closed";

const AlertLGPD = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && !localStorage.getItem(LGPD_KEY)) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(LGPD_KEY, "true");
    }
  };

  if (!open) return null;

  return (
    <div className={styles.lgpdAlertContainer}>
      <div className={styles.lgpdAlertContent}>
        <div className={styles.lgpdAlertHeader}>
          <p className={styles.lgpdAlertTitle}>Política de Privacidade</p>
          <button
            className={styles.lgpdAlertClose}
            aria-label="Fechar aviso de privacidade"
            onClick={handleClose}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd" clipRule="evenodd" d="M1.73529 1.73554C2.02819 1.44265 2.50306 1.44265 2.79595 1.73554L9.99985 8.93943L17.2037 1.73554C17.4966 1.44265 17.9715 1.44265 18.2644 1.73554C18.5573 2.02843 18.5573 2.50331 18.2644 2.7962L11.0605 10.0001L18.2644 17.204C18.5573 17.4969 18.5573 17.9718 18.2644 18.2646C17.9715 18.5575 17.4966 18.5575 17.2037 18.2646L9.99985 11.0608L2.79595 18.2646C2.50306 18.5575 2.02819 18.5575 1.73529 18.2646C1.4424 17.9718 1.4424 17.4969 1.73529 17.204L8.93919 10.0001L1.73529 2.7962C1.4424 2.50331 1.4424 2.02843 1.73529 1.73554Z"
                fill="#373737"
              />
            </svg>
          </button>
        </div>
        <span className={styles.lgpdAlertText}>
          Utilizamos cookies para otimizar e aprimorar a sua navegação, além de
          aperfeiçoar a experiência dos nossos usuários. Ao continuar no site,
          você concorda expressamente com nossa{" "}
          <a
            href={`${process.env.REACT_APP_BASE_URL}/static/img/pol%C3%ADtica_de_privacidade___parceiros_promo___04072023.pdf`}
            className={styles.lgpdAlertLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Política de Privacidade.
          </a>
        </span>
      </div>
    </div>
  );
};

export default AlertLGPD;